export var uiAngleTop = [
    'M8.2 6.34L10.92 9.1C11.03 9.21 11.03 9.39 10.92 9.5L10.75 9.66C10.64 9.77 10.46 9.77 10.35 9.66L8 7.27L5.65 9.66C5.54 9.77 5.36 9.77 5.25 9.66L5.08 9.49C4.97 9.38 4.97 9.21 5.08 9.1L7.8 6.34C7.91 6.23 8.09 6.23 8.2 6.34Z',
];
